// Phase 7 — semantic graph + metric layer metadata, colors and helpers.

export const EDGE_KINDS = ["joins_on", "is_a", "derived_from", "belongs_to", "aggregates"];

// Edge colors: gray inferred · blue verified · red rejected.
export const EDGE_COLOR = {
  verified: "#2563eb", // blue
  rejected: "#ef4444", // red
  inferred: "#94a3b8", // gray
};

export function edgeColor(edge) {
  if (edge.status === "rejected") return EDGE_COLOR.rejected;
  if (edge.verified || edge.status === "confirmed") return EDGE_COLOR.verified;
  return EDGE_COLOR.inferred;
}

export const KIND_BADGE = {
  joins_on: "border-accent/50 text-accent bg-accent/10",
  is_a: "border-sky-500/40 text-sky-400 bg-sky-500/10",
  derived_from: "border-violet-500/40 text-violet-300 bg-violet-500/10",
  belongs_to: "border-amber-500/40 text-amber-400 bg-amber-500/10",
  aggregates: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
};

export const DOMAINS = [
  "Finance", "Sales", "Marketing", "Product", "Engineering", "HR", "Legal", "Operations",
];

export const DOMAIN_BADGE = {
  Finance: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
  Sales: "border-sky-500/40 text-sky-400 bg-sky-500/10",
  Marketing: "border-pink-500/40 text-pink-400 bg-pink-500/10",
  Product: "border-violet-500/40 text-violet-300 bg-violet-500/10",
  Engineering: "border-orange-500/40 text-orange-400 bg-orange-500/10",
  HR: "border-amber-500/40 text-amber-400 bg-amber-500/10",
  Legal: "border-slate-500/40 text-slate-300 bg-slate-500/10",
  Operations: "border-accent/50 text-accent bg-accent/10",
};

export const METRIC_STATUS = {
  draft: { label: "Draft", cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
  active: { label: "Active", cls: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10" },
  deprecated: { label: "Deprecated", cls: "text-muted-foreground border-border/60 bg-muted/40" },
};

export const STATUS_FILTERS = [
  { value: "all", label: "All" },
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "deprecated", label: "Deprecated" },
];

export const SENSITIVITY_DOT = {
  Restricted: "bg-red-500",
  Confidential: "bg-amber-500",
  Internal: "bg-sky-500",
  Public: "bg-emerald-500",
};

export const REVIEW_ROLES = ["owner", "admin", "analyst"];

export function canReviewRole(role) {
  return REVIEW_ROLES.includes(role);
}

export function csvToList(value) {
  return (value || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}
